import request from '@/utils/request';


let server = {
  advertising: '/advertising', // 首页轮播
  configs: '/configs', // 平台信息
  counselors: '/counselors', // 顾问列表
  pointRule: '/point_rule', // 积分抵扣规则
  pointDetailed: '/point_bills', // 积分明细
  bills: '/bills' // 账单明细
};


//  首页轮播
export function advertising(params) {
  return request({
    url: server.advertising,
    method: 'get',
    params
  })
}


//  平台信息
export function configs() {
  return request({
    url: server.configs,
    method: 'get',
  })
}


//  顾问列表
export function counselors(params) {
  return request({
    url: server.counselors,
    method: 'get',
    params
  })
}


//  顾问列表
export function pointRule() {
  return request({
    url: server.pointRule,
    method: 'get',
  })
}


//  积分明细
export function pointDetailed(page) {
  return request({
    url: server.pointDetailed + '?page=' + page,
    method: 'get',
  })
}


//  账户明细
export function bills(page) {
  return request({
    url: server.bills + '?page=' + page,
    method: 'get',
  })
}












// WEBPACK FOOTER //
// ./src/api/other.js